import { render, staticRenderFns } from "./UserPreferences.vue?vue&type=template&id=ab13b33c&scoped=true"
import script from "./UserPreferences.vue?vue&type=script&lang=js"
export * from "./UserPreferences.vue?vue&type=script&lang=js"
import style0 from "./UserPreferences.vue?vue&type=style&index=0&id=ab13b33c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab13b33c",
  null
  
)

export default component.exports